import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Row } from "reactstrap";
import { useFormFields } from "../config/hooksLib";
import { onError } from "../config/errorLib";
import { styled } from "@mui/material/styles";
import "../style/login.css";
import Header from "./Header";
export default function NewUser() {
  const [fields, handleFieldChange] = useFormFields({
    code: "",
    email: "",
    firstName: "",
    lastName: "",
    password: "", // pragma: allowlist secret
    confirmPassword: "", // pragma: allowlist secret
  });
  const [waitingForCode, setWaitingForCode] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [codeResent, setCodeResent] = useState(false);
  const [radioButton, setRadioButton] = useState("password");
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastNameErr, setLastNameErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [passwordErr, setPasswordErr] = useState(false);

  const HelperTextField = styled(TextField)({
    "& .MuiInputBase-root": {
      border: "0px solid",
    },
    "& MuiOutlinedInput-root": {
      border: "0px solid",
    },
  });

  const DialogTheme = createTheme({
    palette: {
      primary: {
        main: "#0073A8",
      },
      secondary: {
        main: "#0073A8",
      },
    },
    overrides: {
      MuiDialog: {
        container: {
          maxWidth: "75vw",
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: "#FFFFFF !important",
        },
      },
      MuiFormHelperText: {
        root: {
          color: "#ccc",
        },
      },
      MuiInput: {
        input: {
          color: "#3E3E3E !important",
        },
        underline: {
          color: "#3E3E3E !important",
        },
      },
      MuiInputLabel: {
        root: {
          color: "#3E3E3E !important",
        },
      },
    },
  });
  const signUp = (e) => {
    e.preventDefault();
    setEmailErr(false);
    setFirstNameErr(false);
    setLastNameErr(false);
    setPasswordErr(false);
    Auth.signUp({
      username: fields.email,
      password: fields.password, // pragma: allowlist secret
      attributes: {
        email: fields.email,
        "custom:first_name": fields.firstName,
        "custom:last_name": fields.lastName,
      },
    })
      .then((data) => {
        console.log(data);
        setWaitingForCode(true);
        setCodeSent(true);
      })
      .catch((err) => {
        if (fields.email === "") {
          setEmailErr(true);
        }
        if (fields.firstName === "") {
          setFirstNameErr(true);
        }
        if (fields.lastName === "") {
          setLastNameErr(true);
        }
        if (fields.password === "") {
          // pragma: allowlist secret
          setPasswordErr(true);
        }
        //onError(err);
        console.log(err);
      });
  };
  const confirmSignUp = (e) => {
    e.preventDefault();
    Auth.confirmSignUp(fields.email, fields.code)
      .then((data) => {
        console.log(data);
        setConfirmed(true);
      })
      .catch((err) => {
        onError(err);
        console.log(err);
      });
  };
  const resendCode = () => {
    Auth.resendSignUp(fields.email)
      .then(() => {
        setCodeResent(true);
        console.log("code resent successfully");
      })
      .catch((err) => {
        onError(`The email entered does not exist`);
        console.log(err);
      });
  };
  const validateCodeForm = () => {
    return (
      fields.email.length > 0 &&
      fields.firstName.length > 0 &&
      fields.lastName.length > 0 &&
      fields.password.length > 0 &&
      fields.password === fields.confirmPassword // pragma: allowlist secret
    );
  };

  const validateConfirmationForm = () => {
    return fields.code.length > 0;
  };
  const handleClose = () => {
    window.location.href = "/";
  };

  const handleRadioChange = (event) => {
    setRadioButton(event.target.value);
  };

  const renderSignUpForm = () => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        style={{
          width: "60%",
          marginTop: 68,
          left: "50%",
          borderRadius: 4,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: 4,
            padding: 30,
            boxShadow: "0px 3px 3px #dedede",
          }}
        >
          <div style={{ width: "85%" }}>
            <span
              style={{
                color: "#404040",
                fontWeight: "bold",
                fontSize: 17,
              }}
            >
              User Information
            </span>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              sx={{
                marginTop: "30px",
                marginBottom: "35px",
              }}
            >
              <TextField
                variant="outlined"
                autoFocus
                margin="dense"
                fullWidth={true}
                id="email" //cannot type without this saying email but unsure if it needs to say username
                label="Email Address"
                type="email"
                InputLabelProps={{
                  style: {
                    fontSize: 12,
                  },
                }}
                inputProps={{
                  style: {
                    fontSize: 13,
                  },
                }}
                value={fields.email}
                onChange={handleFieldChange}
                helperText="Field cannot be empty"
                FormHelperTextProps={{
                  style: {
                    color: "red",
                    fontSize: 12,
                    display: emailErr ? "flex" : "none",
                  },
                }}
              />
            </Box>
          </div>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: 4,
            padding: 20,
            marginTop: "25px",
            boxShadow: "0px 3px 3px #dedede",
          }}
        >
          <div
            style={{ width: "85%", marginTop: "20px", marginBottom: "20px" }}
          >
            <span
              style={{
                color: "#404040",
                fontWeight: "bold",
                fontSize: 17,
              }}
            >
              Account Information
            </span>
            <RadioGroup
              row
              value={radioButton}
              onChange={handleRadioChange}
              style={{ marginTop: "23px" }}
            >
              <FormControlLabel
                value="password"
                control={<Radio color="primary" />}
                label={
                  <Typography className="radioButtonText">
                    Create Password
                  </Typography>
                }
              />
              <div style={{ marginRight: "33px" }} />
              <FormControlLabel
                value="code"
                control={<Radio color="primary" />}
                label={
                  <Typography className="radioButtonText">
                    Use a Code
                  </Typography>
                }
              />
            </RadioGroup>
            {radioButton === "code" ? renderUseCode() : renderCreatePassword()}
          </div>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          style={{ marginTop: "45px" }}
        >
          {radioButton === "code" ? (
            <Button
              onClick={confirmSignUp}
              color="primary"
              disabled={fields.email === "" || !validateConfirmationForm()}
              className="button-text"
              style={{
                color: "#ffffff",
                fontSize: 15,
                fontWeight: "bold",
                borderColor: "white",
                height: 42,
                width: 227,
                borderRadius: 4,
                marginTop: 0,
                backgroundColor: "#0073a8",
                marginBottom: "20px",
                opacity:
                  fields.email === "" || !validateConfirmationForm() ? 0.5 : 1,
              }}
            >
              Confirm
            </Button>
          ) : (
            <Button
              onClick={signUp}
              color="primary"
              className="button-text"
              style={{
                color: "#ffffff",
                fontSize: 15,
                fontWeight: "bold",
                borderColor: "white",
                height: 42,
                width: 227,
                borderRadius: 4,
                marginTop: 0,
                backgroundColor: "#0073a8",
                marginBottom: 20,
              }}
            >
              Sign Up
            </Button>
          )}
          <Link to="/" style={{ all: "unset" }}>
            <Button className="blueTouchableText">Cancel</Button>
          </Link>
        </Box>
      </Box>
    );
  };

  function renderCreatePassword() {
    return (
      <Box display="flex" flexDirection="column">
        <Box
          display="flex"
          flexDirection="row"
          sx={{ marginTop: "10px", marginBottom: "15px" }}
        >
          <TextField
            variant="outlined"
            margin="dense"
            id="firstName"
            label="First Name"
            type="string"
            fullWidth
            style={{ marginRight: 24 }}
            InputLabelProps={{
              style: {
                fontSize: 12,
              },
            }}
            inputProps={{
              style: {
                fontSize: 13,
              },
            }}
            value={fields.firstName}
            onChange={handleFieldChange}
            helperText="Field cannot be empty"
            FormHelperTextProps={{
              style: {
                color: "red",
                fontSize: 12,
                display: firstNameErr ? "flex" : "none",
              },
            }}
          />
          <TextField
            variant="outlined"
            margin="dense"
            id="lastName"
            label="Last Name"
            type="string"
            fullWidth
            InputLabelProps={{
              style: {
                fontSize: 12,
              },
            }}
            inputProps={{
              style: {
                fontSize: 13,
              },
            }}
            value={fields.lastName}
            onChange={handleFieldChange}
            helperText="Field cannot be empty"
            FormHelperTextProps={{
              style: {
                color: "red",
                fontSize: 12,
                display: lastNameErr ? "flex" : "none",
              },
            }}
          />
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          sx={{ marginBottom: "20px" }}
        >
          <TextField
            variant="outlined"
            margin="dense"
            id="password"
            label="Password"
            type="password"
            helperText="Minimum 8 characters and must contain a number, lowercase, uppercase, and special character"
            fullWidth
            style={{ marginRight: 24 }}
            InputLabelProps={{
              style: {
                fontSize: 12,
              },
            }}
            inputProps={{
              style: {
                fontSize: 13,
              },
            }}
            value={fields.password}
            onChange={handleFieldChange}
          />
          <TextField
            variant="outlined"
            margin="dense"
            id="confirmPassword"
            label="Confirm Password"
            type="password"
            fullWidth
            InputLabelProps={{
              style: {
                fontSize: 12,
              },
            }}
            inputProps={{
              style: {
                fontSize: 13,
              },
            }}
            helperText={
              passwordErr
                ? "Password fields cannot be empty."
                : fields.password !== fields.confirmPassword &&
                  fields.confirmPassword !== ""
                ? "Passwords do not match"
                : null
            }
            FormHelperTextProps={{
              style: {
                color: "red",
                fontSize: 12,
                display:
                  (fields.password !== fields.confirmPassword &&
                    fields.confirmPassword !== "") ||
                  passwordErr
                    ? "flex"
                    : "none",
              },
            }}
            value={fields.confirmPassword}
            onChange={handleFieldChange}
          />
          {/* <HelperTextField
            style={{ position: "absolute", right: 528, marginTop: 50 }}
            margin="dense"
            variant="standard"
            InputProps={{
              disableUnderline: true,
            }}
            helperText="Field cannot be empty"
            FormHelperTextProps={{
              style: {
                color: "red",
                fontSize: 12,
                display: passwordErr ? "flex" : "none",
              },
            }}
          /> */}
        </Box>
      </Box>
    );
  }

  function renderUseCode() {
    return (
      <Box display="flex" flexDirection="column" style={{ marginTop: "10px" }}>
        <TextField
          variant="outlined"
          autoFocus
          margin="dense"
          id="code"
          label="Confirmation Code"
          type="tel"
          fullWidth
          style={{ marginLeft: 8 }}
          InputLabelProps={{
            style: {
              fontSize: 12,
            },
          }}
          inputProps={{
            style: {
              fontSize: 13,
            },
          }}
          value={fields.code}
          onChange={handleFieldChange}
        />
        <div
          className="blueTouchableContainer"
          style={{ marginTop: 20, opacity: fields.email === "" ? 0.5 : 1 }}
          onClick={fields.email === "" ? null : resendCode}
        >
          <span
            style={{
              color: "#0073a8",
              fontWeight: "bold",
              fontSize: 13,
            }}
          >
            Resend Code
          </span>
        </div>
        {codeResent ? (
          <Row justifyContent="center">
            <Typography
              component="div"
              style={{
                fontSize: 16,
                color: "yellow",
                paddingTop: 2,
              }}
            >
              If the user exists, a confirmation code has been resent to the
              email.
            </Typography>
          </Row>
        ) : null}
      </Box>
    );
  }

  function renderConfirmationForm() {
    return (
      <ThemeProvider theme={DialogTheme}>
        <Dialog
          open={waitingForCode}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          style={{
            display: "flex",
            alignSelf: "center",
            justifyContent: "center",
            backgroundColor: "#ffffff",
          }}
        >
          <Box
            style={{
              backgroundColor: "#ffffff",
              borderRadius: 4,
              padding: 30,
              width: 600,
            }}
          >
            <span
              style={{
                color: "#404040",
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              Confirm Email
            </span>
            <div style={{ marginTop: "10px" }} />
            <DialogContent>
              <TextField
                variant="outlined"
                autoFocus
                margin="dense"
                id="email"
                label="Email Address"
                type="email"
                fullWidth
                InputLabelProps={{
                  style: {
                    fontSize: 12,
                  },
                }}
                inputProps={{
                  style: {
                    fontSize: 13,
                  },
                }}
                value={fields.email}
                onChange={handleFieldChange}
              />
            </DialogContent>
            <DialogContent>
              <TextField
                variant="outlined"
                margin="dense"
                fullWidth={true}
                id="code"
                label="Confirmation Code"
                type="tel"
                InputLabelProps={{
                  style: {
                    fontSize: 12,
                  },
                }}
                inputProps={{
                  style: {
                    fontSize: 13,
                  },
                }}
                value={fields.code}
                onChange={handleFieldChange}
              />
            </DialogContent>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Button
                onClick={resendCode}
                className="blueTouchableText"
                disabled={fields.email === ""}
              >
                Resend code
              </Button>
              <Button
                onClick={confirmSignUp}
                className="button-text"
                style={{
                  color: "#ffffff",
                  fontSize: 15,
                  fontWeight: "bold",
                  borderColor: "white",
                  height: 42,
                  width: 227,
                  borderRadius: 4,
                  backgroundColor: "#0073a8",
                  marginBottom: 20,
                  marginTop: 15,
                  opacity: !validateCodeForm() ? 0.5 : 1,
                }}
                disabled={!validateConfirmationForm()}
              >
                Confirm
              </Button>
            </Box>
          </Box>
        </Dialog>
      </ThemeProvider>
    );
  }
  function renderSuccessMessage() {
    return (
      <div className="success sendForm">
        <p style={{ color: "white" }}>Your email has been confirmed.</p>
        <Link to="/">
          <Button color="primary" style={{ fontSize: "24" }}>
            Return to Login
          </Button>
        </Link>
      </div>
    );
  }
  return (
    <div className="ResetPassword">
      <Header auth={false} />
      <div style={{ marginTop: 44 }} />
      <Box>
        <span
          style={{
            fontWeight: "bold",
            fontSize: 36,
            color: "#333333",
            marginLeft: 137,
          }}
        >
          Register Account
        </span>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center">
        {!codeSent
          ? renderSignUpForm()
          : !confirmed
          ? renderConfirmationForm()
          : renderSuccessMessage()}
      </Box>
    </div>
  );
}
